import { render, staticRenderFns } from "./DisposeFACoalManager.vue?vue&type=template&id=0e971465&scoped=true&"
import script from "./DisposeFACoalManager.vue?vue&type=script&lang=js&"
export * from "./DisposeFACoalManager.vue?vue&type=script&lang=js&"
import style0 from "./DisposeFACoalManager.vue?vue&type=style&index=0&id=0e971465&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e971465",
  null
  
)

export default component.exports